import { Directive, HostListener, ElementRef, Renderer2, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { ErrorFacade } from '../../../facades/error.facade';
import { CONSTANTS_FORMS as CONST } from '../mo-forms.constant';
import { FORM_VALIDATE_CONSTANTS as MESSAGESS } from './form-validate.constant';

@Directive({
  selector: '[validateForm]',
})
export class FormValidateDirective {
  @Input('validateForm') form: UntypedFormGroup;

  constructor(
    private _el: ElementRef,
    private _renderer: Renderer2,
    private _errorFacade: ErrorFacade
  ) {}

  @HostListener('submit', ['$event'])
  onSubmit(_: any) {
    this._focusFirstError();
  }
  private _focusFirstError() {
    let selector = `
        .ng-invalid[formcontrolname]:not(.form) input,
        input.ng-invalid
      `;
    this._renderer.addClass(this._el.nativeElement, 'submited');

    const error = this.checkDiferentError(this.form);
    if (error) {
      const message = error.message ? error.message : error;
      this._errorFacade.handleError(message);
      if (error.control) {
        selector = `[formcontrolname=${error.control}]:not(.form) input`;
      }
    }

    const invalidElements = this._el.nativeElement.querySelector(selector);
    if (invalidElements) {
      invalidElements.focus();
    }
  }

  checkDiferentError(control: AbstractControl | UntypedFormGroup, controlName?: string) {
    const errorsChild = this.checkControlError(control);
    if (errorsChild) return errorsChild;
    if (!control.errors) return null;
    const name = controlName;

    for (const errorName in control.errors) {
      const error = control.errors[errorName];
      if (errorName === 'required') {
        return CONST.MESSAGES.ERROR_FIELD_REQUIRED;
      }
      if (errorName === 'minlength') {
        const { requiredLength } = error;
        return MESSAGESS.VALIDATOR_MIN[name].replace('{{min}}', requiredLength.toString());
      }
      if (errorName === 'maxlength') {
        const { requiredLength } = error;
        return MESSAGESS.VALIDATOR_MAX[name].replace('{{max}}', requiredLength.toString());
      }
      if (errorName === 'min') {
        const min = error.min;
        return MESSAGESS.VALIDATOR_MIN[name].replace('{{min}}', min.toString());
      }
      if (errorName === 'max') {
        const max = error.max;
        return MESSAGESS.VALIDATOR_MAX[name].replace('{{max}}', max.toString());
      }
      if (errorName === 'address') {
        return CONST.MESSAGES.ERROR_ADDRESS;
      }
      if (errorName === 'pattern') {
        return CONST.MESSAGES.ERROR_9_PHONE;
      }
      return error;
    }
  }

  checkControlError(control: AbstractControl | UntypedFormGroup) {
    if (control instanceof UntypedFormGroup) {
      for (const key in control.controls) {
        const child = control.controls[key];
        const error = this.checkDiferentError(child, key);
        if (error) {
          return error;
        }
      }
    }
  }
}
